import React from "react";
import KPICard, { type KPICardProps } from "./KPICard";

type AllFindingsKPIProps = Omit<KPICardProps, "groupBy" | "severity">;

const AllFindingsKPI: React.FC<AllFindingsKPIProps> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  widgetKey,
  setIsReadyToExport = null,
}) => {
  return (
    <KPICard
      selectedScope={selectedScope}
      filterToExecute={filterToExecute}
      scopeToExecute={scopeToExecute}
      groupBy={[]}
      severity={"all"}
      widgetKey={widgetKey}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default AllFindingsKPI;
